module.exports = __webpack_public_path__ + "static/img/ikonaGaleriaDisabled-OFF.fae59378.png";